<template>
  <div
      style="
       background-color: #cbeefd;
       border-color: #0fb6fe;
       border-radius: 15px;
       border-style: solid;
       border-width: 3px;
       padding:20px;"
  >
    {{question}}

    <div v-for="(anOption, i) in options" :key="`opt-${i}`">
      {{i + 1}}. {{anOption}}
    </div>

  </div>
</template>

<script>
export default {
  name: "Display_PaneResponse_Encouraging_Words",
  components: {},
  created(){},
  mounted() {},
  props: {
    poll: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
  },
  computed: {
    question(){
      return this.poll && this.poll.question ? this.poll.question : "";
    },
    options() {
      return this.poll && this.poll.options && Array.isArray(this.poll.options) ?
          this.poll.options : "";
    }

  },
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
